import * as t from 'io-ts';
import { mixed, optional } from '../../validation/validator';
import { CallResponseSchema } from '../common/callResponseSchema';

export const GuideRecordSchema = t.type({
  id: t.number,
  name: t.string,
  title: t.string,
  video_id: t.string,
});


export const GetGuidesRequestSchema = optional({
  ids: t.array(t.number),
})

export const GetGuidesResponseSchema = t.type({
  guides: t.array(GuideRecordSchema),
})

export type GuideRecord = t.TypeOf<typeof GuideRecordSchema>;
export type GetGuidesRequest = t.TypeOf<typeof GetGuidesRequestSchema>;
export type GetGuidesResponse = t.TypeOf<typeof GetGuidesResponseSchema>;



export const GuideApis = {
  Guides: {
    GetGuides: {
      Name: 'guides-getGuides',
      Request: GetGuidesRequestSchema,
      Response: mixed([t.type({
        data: t.array(GuideRecordSchema)
    }), CallResponseSchema])
    }
  }
}